import {
  PRICE_BOOK_ADD_ANOTHER_FIELDS,
  type PriceBookAddAnotherConfig,
  type PriceBookAddAnotherField,
} from '@jaluzi/types';

/** Нынешнее безопасное поведение: изделие/материал/карниз остаются, а все
 * производственные ответы начиная с планки спрашиваются заново. */
export const DEFAULT_ADD_ANOTHER_FIELDS: readonly PriceBookAddAnotherField[] = [
  'SLAT',
  'BORT',
  'BAHROMA',
  'MECHANISM',
  'DIMENSIONS',
];

const fieldSet = new Set<string>(PRICE_BOOK_ADD_ANOTHER_FIELDS);

/**
 * Настройка задаёт единую точку продолжения для параметров изделия. Размеры
 * являются отдельной последней галочкой: их можно повторить или сохранить
 * независимо от выбранной точки продолжения.
 */
export function normalizeAddAnotherFields(
  value: readonly string[] | null | undefined,
): PriceBookAddAnotherField[] {
  const selected = new Set((value ?? []).filter((field) => fieldSet.has(field)));
  const repeatDimensions = selected.has('DIMENSIONS');
  const first = PRICE_BOOK_ADD_ANOTHER_FIELDS.findIndex(
    (field) => field !== 'DIMENSIONS' && selected.has(field),
  );
  if (first < 0) return repeatDimensions ? ['DIMENSIONS'] : [];
  return PRICE_BOOK_ADD_ANOTHER_FIELDS.slice(first).filter((field) => (
    field !== 'DIMENSIONS' || repeatDimensions
  )) as PriceBookAddAnotherField[];
}

export function addAnotherFieldsForSection(
  config: PriceBookAddAnotherConfig | null | undefined,
  sectionCode: string | null | undefined,
): PriceBookAddAnotherField[] {
  if (!sectionCode || !Object.prototype.hasOwnProperty.call(config?.bySection ?? {}, sectionCode)) {
    return normalizeAddAnotherFields(DEFAULT_ADD_ANOTHER_FIELDS);
  }
  return normalizeAddAnotherFields(config!.bySection[sectionCode]);
}

/** Переключение галочки: параметры каскадные, размеры — независимые. */
export function toggleAddAnotherField(
  current: readonly PriceBookAddAnotherField[],
  field: PriceBookAddAnotherField,
  enabled: boolean,
): PriceBookAddAnotherField[] {
  if (field === 'DIMENSIONS') {
    return normalizeAddAnotherFields(enabled
      ? [...current, 'DIMENSIONS']
      : current.filter((candidate) => candidate !== 'DIMENSIONS'));
  }
  const index = PRICE_BOOK_ADD_ANOTHER_FIELDS.indexOf(field);
  if (enabled) {
    const dimensions = current.includes('DIMENSIONS') ? ['DIMENSIONS' as const] : [];
    return normalizeAddAnotherFields([
      ...PRICE_BOOK_ADD_ANOTHER_FIELDS.slice(index).filter((candidate) => candidate !== 'DIMENSIONS'),
      ...dimensions,
    ]);
  }
  const selected = normalizeAddAnotherFields(current);
  return normalizeAddAnotherFields(selected.filter((candidate) => (
    candidate === 'DIMENSIONS' || PRICE_BOOK_ADD_ANOTHER_FIELDS.indexOf(candidate) > index
  )));
}
